import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import GlobalState from '../../../../stores/GlobalState'
import Pagination from '../../../common/Pagination'
// import { ReactComponent as Logo } from '../../../../assets/logo.svg'
import classNames from 'classnames'
import loader from '../../../../assets/loaders/np-preloader1.gif'

const TerminalsTable = observer(
  ({
    content,
    dt,
    setTerm,
  }: {
    content: any
    dt: any
    setTerm?: (value?: any) => void
  }) => {
    const [isLoad, setLoad] = useState(false)
    const days = GlobalState.currentLocale.lang.includes('En')
      ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      : [
          'Пн',
          'Вт',
          'Ср',
          'Чт',
          'Пт',
          'Сб',
          GlobalState.currentLocale.lang.includes('ру') ? 'Вс' : 'Нд',
        ]
    const [currentPage, setCurrentPage] = useState(1)
    const [lastPage, setLastPage] = useState(0)
    const [width, setWidth] = useState(window.innerWidth)
    const [showMore, setMore] = useState(0)
    const [countPerPage, setCount] = useState(10)
    const [count, setPageCount] = useState(Array())
    const [currentItems, setCurrentItems] = useState<Array<any> | null>([])
    const [currentTableData, setData] = useState<Array<any> | null | undefined>(
      Array(),
    )

    useEffect(() => {
      let prev = 0
      if (currentPage - 1) {
        for (let i = currentPage - 2; i >= 0; i--) {
          prev += count[i]
        }
      }
      const firstPageIndex = prev
      const lastPageIndex = firstPageIndex + count[currentPage - 1]

      setData(currentItems?.slice(firstPageIndex, lastPageIndex))
    }, [currentPage, currentItems, count])

    useEffect(() => {
      setMore(0)
    }, [dt])

    useEffect(() => {
      if (showMore) {
        let arr = count
        arr[currentPage - 1] += count[currentPage] ? count[currentPage] : 0

        arr.splice(currentPage, 1)
        setPageCount([...arr])
      }
    }, [showMore])

    useEffect(() => {
      setMore(0)
    }, [currentPage])

    useEffect(() => {
      if (!dt) {
        setLoad(true)
        return
      }
      setLoad(false)
      setCurrentItems(dt)

      const cnt = Math.ceil(dt.length / countPerPage)
      const arr: Array<number> = []
      let maxLength = dt.length
      for (let i = cnt - 1; i >= 0; i--) {
        arr.push(maxLength - countPerPage * i)
        maxLength -= maxLength - countPerPage * i
      }
      setPageCount(arr.reverse())
    }, [dt])

    const timeWork = (isStart: boolean, shedule: any) => {
      const ars = Object.entries(shedule)

      let start: any = '',
        end: any = ''

      ars.forEach((a, i) => {
        if (!i && isStart) {
          start = a[1]
        }

        if (i == 6 && !isStart) start = a[1]
      })

      return `${start}`
    }

    const getDays = (shedule: any, isWorkWeek: boolean) => {
      const ars = Object.entries(shedule)

      let start: any = '',
        end: any = ''

      ars.forEach((a, i) => {
        if (!i && isWorkWeek) {
          start = days[0]
        }

        if (i == 4 && a[0].includes('Fri') && isWorkWeek) {
          end = days[4]
        }

        if (i == 5 && a[0].includes('Sat') && !isWorkWeek) {
          start = days[5]
        }
        if (i == 6 && a[0].includes('Sun') && !isWorkWeek) {
          end = days[6]
        }
      })

      return `${start}-${end}`
    }

    return (
      <>
        <div className="terminals-col__table-cont">
          <div className={classNames('tariffs__loader', isLoad && 'loader')}>
            <img src={loader} />
          </div>
          <table className="terminals-col__table">
            <thead>
              {content.headlines.map((h: any, i: number) => (
                <th className="terminals-col__table-title" key={i}>
                  {h}
                </th>
              ))}
            </thead>
            <tbody>
              {currentTableData?.map((d: any, i: number) => (
                <tr
                  key={i}
                  onClick={() => {
                    setTerm && setTerm(d)
                    window.scroll(0, 0)
                  }}
                >
                  <td>{d.TypeOfWarehouse.split(':').shift()}</td>
                  <td>{d.ShortAddress}</td>
                  <td>
                    <div className="terminals-col__days">
                      <span>{getDays(d.Schedule, true)}</span>
                      {timeWork(true, d.Schedule)}
                    </div>
                    <div className="terminals-col__days">
                      <span>{getDays(d.Schedule, false)}</span>{' '}
                      {timeWork(false, d.Schedule)}
                    </div>
                  </td>
                  <td className="terminals-col__days">
                    {+d.TotalMaxWeightAllowed > 0
                      ? d.TotalMaxWeightAllowed
                      : d.PlaceMaxWeightAllowed}{' '}
                    {content.kilo}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {currentItems && currentItems.length ? (
          <div className="news-page__bottom">
            <Pagination
              getLastPage={(value) => setLastPage(value)}
              currentPage={currentPage}
              setCurrentPage={(value) => {
                setCurrentPage(value)
                window.scrollTo(0, 0)
              }}
              data={currentItems as any}
              itemsPerPage={count.length}
            />

            {currentPage != lastPage && (
              <div
                className="button black"
                onClick={() => {
                  setMore(showMore + countPerPage)
                }}
              >
                {content.showButton}
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
      </>
    )
  },
)

export default TerminalsTable
